<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Thank you!</h1>
    <p>Your benefit in kind information has been saved, please check your onboarding dashboard for further tasks that are due to be completed.</p>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>